<template>
    <kgr-offering-view
        v-if="offering !== null"
        :club-id="clubId"
        :offering="offering"
        :user-id="userId"
        :error="error"
        :duplicate-generic-url="duplicateGenericUrl"
        :can-duplicate="canDuplicate"
        :can-edit="canEdit"
    />
</template>

<script>
import Error from '../../js/model/Error.js';
import GenericOfferingRepository from '../../js/repository/club/offering/GenericOfferingRepository.js';
import OfferingView from '../../components/offering/OfferingView.vue';

export default {
    components: {
        'kgr-offering-view': OfferingView,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        duplicateGenericUrl: {
            type: String,
            required: true,
        },
        canDuplicate: {
            type: Boolean,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showCalendar: true,
            showList: false,
            appointments: [],
            offering: null,
            error: new Error(),
        }
    },
    computed: {},
    created() {
        GenericOfferingRepository.find(this.offeringId)
            .then(offering => this.offering = offering)
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {},
}

</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
